import { useArtistsStore } from './artists-store';
import { useVoterEmailsStore } from './emails-store';
import { useMediaStore } from './media-store';
import { useNotificationsStore } from './notifications-store';
import { useProjectsStore } from './projects-store';
import { useProposalsStore } from './proposals-store';
import { clearResourceCache } from './resource';
import { useSubscribersStore } from './subscribers-store';
import { useVotesStore } from './votes-store';
import { useVotingStore } from './voting-store';

/**
 * Wipes all client-side state so the next sign-in starts clean: every list's
 * query state (search, filter, sort, pagination) plus the resource cache.
 * Add new query stores here.
 */
export function resetClientState(): void {
  useArtistsStore.getState().reset();
  useVoterEmailsStore.getState().reset();
  useMediaStore.getState().reset();
  useNotificationsStore.getState().reset();
  useProjectsStore.getState().reset();
  useProposalsStore.getState().reset();
  useSubscribersStore.getState().reset();
  useVotesStore.getState().reset();
  useVotingStore.getState().reset();
  clearResourceCache();
}
